var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDmsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 42,
    viewBox: "0 0 130 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.133301 0.843079H18.4666C31.3152 0.843079 40.1518 8.59936 40.1518 20.9989C40.1518 33.3983 31.3152 41.1546 18.4666 41.1546H0.133301V0.843079ZM18.0096 32.0793C24.6116 32.0793 29.0299 27.9637 29.0299 20.9989C29.0299 14.034 24.6116 9.91846 18.0096 9.91846H11.052V32.0265H18.0096V32.0793Z",
    fill: "#0061F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9825 41.1546L80.8809 19.7853L70.8763 37.1973H66.0009L56.0979 20.3657V41.1546H45.9409V0.843079H54.9806L68.591 24.1119L81.8966 0.843079H90.9363L91.0379 41.1546H80.9825Z",
    fill: "#0061F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1167 37.5151L99.7224 29.1256C103.176 31.5 108.051 33.0829 112.52 33.0829C117.091 33.0829 118.818 31.7638 118.818 29.8116C118.818 23.4271 96.7261 28.0704 96.7261 13.0854C96.7261 5.85678 102.363 0 113.942 0C118.97 0 124.201 1.21357 128.01 3.53518L124.607 12.0302C120.9 9.97236 117.243 8.91709 113.841 8.91709C109.219 8.91709 107.594 10.5528 107.594 12.5578C107.594 18.7312 129.635 14.0879 129.635 28.9673C129.635 35.9849 123.998 42 112.419 42C106.121 42 99.7732 40.206 96.1167 37.5151Z",
    fill: "#0061F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmsLogo);
export default __webpack_public_path__ + "static/media/dms_logo.1ce889018eb799a582c491f0465c1ebb.svg";
export { ForwardRef as ReactComponent };